import type { CSSProperties, ReactNode } from "react";
import { ArtistIcon } from "../icons/ArtistIcon";

export interface AvatarProps {
	readonly name: string;
	readonly src?: string;
	readonly size?: number;
	readonly className?: string;
	readonly children?: ReactNode;
}

/**
 * Avatar — circular avatar with a person-glyph fallback. Mirrors `DSAvatar`
 * on iOS. Size is driven by the `--avatar-size` custom property.
 */
export function Avatar({
	name,
	src,
	size = 44,
	className = "",
	children,
}: Readonly<AvatarProps>) {
	const style: CSSProperties = {
		"--avatar-size": `${size}px`,
	} as CSSProperties;
	return (
		<span className={`ds-avatar ${className}`.trim()} style={style}>
			{src === undefined ? (
				(children ?? <ArtistIcon name="person" size={Math.round(size * 0.5)} />)
			) : (
				// biome-ignore lint/performance/noImgElement: small avatar sized via CSS custom property; next/image adds no value at these sizes on a static-export site
				<img src={src} alt={name} />
			)}
		</span>
	);
}
